export var dncStdMapper = function (response) {
    if (response)
        return response.map(function (x) {
            return {
                taskCat_ID: x.taskCat_ID,
                taskCat_Name: x.taskCat_Name,
            };
        });
    return [];
};
